export { default as BrickCircle } from './BrickCircle';
export { default as BrickSquare } from './BrickSquare';
export { default as BrickOctagon } from './BrickOctagon';

export { default as BrickConnection } from './BrickConnection';
export { default as BrickSquareEndpoints } from './BrickSquareEndpoints';
export { default as BrickCircleEndpoints } from './BrickCircleEndpoints';